<template>
  <section id="formulario" class="bg-[#434654] p-6 plex-regular">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700"
      @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl bg-white rounded-lg p-6">



        <div class="w-full pb-6 text-center">
          <h1 class="plex-semibold text-3xl text-gray-800">ACREDITACIÓN DE PRENSA</h1>
          <h1 class="plex-semibold text-gray-800">Por favor complete el formulario en su totalidad</h1>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">DNI / Pasaporte</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" placeholder="DNI / Pasaporte" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="dni" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" placeholder="Nombre" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" placeholder="Apellido" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="apellido" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Nombre del Medio</label>
            <Field name="nombreMedio" v-slot="{ field, errors }" v-model="formData.nombreMedio">
              <InputText v-bind="field" type="text" placeholder="Nombre del Medio" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombreMedio" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Cargo / Función</label>
            <Field name="cargo" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.cargo">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                placeholder="Seleccione el cargo" :options="cargos" optionLabel="descripcion" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="cargo" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" v-if="formData.cargo?.id === 4">
          <div class="w-full px-2">
            <label class="block mb-1">Especifique su cargo o función</label>
            <Field name="otroCargo" v-slot="{ field, errors }" v-model="formData.otroCargo">
              <InputText v-bind="field" type="text" placeholder="Especifique su cargo o función" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="otroCargo" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <div class="flex flex-wrap -mx-2">
              <div class="w-full md:w-3/12 px-2">
                <label class="block mb-1">País Tel.</label>
                <Select v-model="selectedCountryPhone" filter :options="paises" optionLabel="descripcion"
                  placeholder="País" class="input-base input-success" />
              </div>
              <div class="w-full md:w-1/12 px-2">
                <label class="block mb-1">Código</label>
                <InputText type="text" v-if="selectedCountryPhone !== null" v-model="selectedCountryPhone.id"
                  class="input-base input-success" readonly />
              </div>
              <div class="w-full md:w-3/12 px-2">
                <label class="block mb-1">Cód. Área</label>
                <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
                  <InputText v-bind="field" type="text" placeholder="Cód. Área (sin 0)" class="input-base"
                    :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                  <span class="text-sm text-red-500 p-error">
                    <ErrorMessage name="codigoArea" />
                  </span>
                </Field>
              </div>
              <div class="w-full md:w-5/12 px-2">
                <label class="block mb-1">Tel. Celular</label>
                <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
                  <InputText v-bind="field" type="text" placeholder="Nro (sin 15)" class="input-base"
                    :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                  <span class="text-sm text-red-500 p-error">
                    <ErrorMessage name="telefonoCelular" />
                  </span>
                </Field>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" placeholder="Mail" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">País (Residencia)</label>
            <Field name="paisResidencia" v-slot="{ handleChange, handleBlur, value, errors }"
              v-model="formData.paisResidencia">
              <Select filter @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }"
                placeholder="País de residencia" class="input-base" :options="paises" optionLabel="descripcion" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="paisResidencia" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-1/2" v-if="formData.paisResidencia?.id == '+54'">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="provincia" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-1/2" v-if="formData.paisResidencia?.id != '+54'">
            <label class="block mb-1">Provincia / Estado</label>
            <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provinciaEstado">
              <InputText v-bind="field" type="text" placeholder="Ingrese su provincia o estado" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="provinciaEstado" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>
    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';


import jsonCountries from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';
import jsonCargos from '@/data/cargos.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, IdLabelEntity, OrigenAcreditado, StringIdLabelEntity } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, A_VERIFICAR } from "qreventos-suite/constantes";


interface Pais extends StringIdLabelEntity { }
interface Provincia extends IdLabelEntity { }
interface Cargo extends IdLabelEntity { }

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Select,
    Field, ErrorMessage, Form
  },
  data() {
    return {
      paises: jsonCountries as Pais[],
      provincias: jsonProvincias as Provincia[],
      selectedCountryPhone: { "id": "+54", "descripcion": "Argentina" } as Pais,
      isSubmitting: false,
      cargos: [] as Cargo[],
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        nombreMedio: '',
        codigoArea: '',
        telefonoCelular: '',
        mail: '',
        paisResidencia: { "id": "+54", "descripcion": "Argentina" } as Pais,
        provincia: undefined as unknown as Provincia,
        provinciaEstado: '',
        cargo: undefined as unknown as Cargo,
        otroCargo: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required('Ingrese el DNI').min(8, 'Al menos 8 números'),
        nombre: yup.string().required('Ingrese el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese el apellido').min(3, 'Al menos 3 letras'),
        nombreMedio: yup.string().required('Ingrese el nombre del medio').min(2, 'Al menos 2 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
        codigoArea: yup.string().required('Ingrese el código de área').matches(/^\d+$/, 'Solo se permiten números'),
        telefonoCelular: yup.string().required('Ingrese el celular').matches(/^\d+$/, 'Solo se permiten números'),
        cargo: yup.mixed().required('Seleccione el cargo'),
        otroCargo: yup.string().test('validacion-otro-cargo', 'Debes especificar su cargo o función', function (value) {
          const cargoSelected = this.parent.cargo;
          if (cargoSelected?.id === 4 && !value) {
            return false;
          }
          return true;
        }),
        provincia: yup.mixed().test('validacion-provincia-argentina', 'Seleccione la provincia', function (value) {
          const paisSelected = this.parent.paisResidencia;
          if (paisSelected?.id == '+54' && !value) {
            return false;
          }
          return true;
        }),
        provinciaEstado: yup.string().test('validacion-provincia-otro', 'Ingrese la provincia/estado', function (value) {
          const paisSelected = this.parent.paisResidencia;
          if (paisSelected?.id != '+54' && !value) {
            return false;
          }
          return true;
        }),
      });
    }
  },
  watch: {
    'formData.cargo.id'(newValue) {
      if (newValue !== 4) {
        this.formData.otroCargo = '';
      }
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Revise el formulario<br>Hay " + errores + " error/es", icon: "error" });
    },
    async onSubmit() {
      let acreditadoExistente: Acreditado[] = await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni=" + encodeURIComponent(this.formData.dni));
      if (acreditadoExistente.length > 0) {
        this.isSubmitting = false;
        Swal.fire({ title: "Atención", html: "El documento ingresado ya se encuentra registrado en una solicitud de acreditación.<br><br>En caso de no recibir el correo electrónico, y siempre que su acreditación haya sido aprobada, podrá descargar la credencial desde el botón \"YA ME ACREDITÉ\" de esta página.", icon: "info" }).then(() => {
          this.isSubmitting = false;
        });
        return;
      }

      acreditadoExistente = await suiteService.findAcreditadosByFilters(suiteConfig.evento, "mail=" + encodeURIComponent(this.formData.mail));
      if (acreditadoExistente.length > 0) {
        this.isSubmitting = false;
        Swal.fire({ title: "Atención", html: "El correo electrónico ingresado ya se encuentra registrado en una solicitud de acreditación.<br><br>En caso de no recibir el correo electrónico, y siempre que su acreditación haya sido aprobada, podrá descargar la credencial desde el botón \"YA ME ACREDITÉ\" de esta página.", icon: "info" }).then(() => {
          this.isSubmitting = false;
        });
        return;
      }
      this.isSubmitting = true;

      let acreditado: Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 2447 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": A_VERIFICAR } as EstadoAcreditado;
      acreditado.dni = this.formData.dni;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.telefono = this.selectedCountryPhone.id + this.formData.codigoArea + this.formData.telefonoCelular;
      acreditado.mail = this.formData.mail;

      if (this.formData.cargo?.id === 4) {
        acreditado.cargo = this.formData.otroCargo;
      } else {
        acreditado.cargo = this.formData.cargo?.descripcion;
      }

      acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.modificado = SAVE; // SAVE
      acreditado.cantidad = 1;
      acreditado.notificar = true;

      // nombre del medio en dato1, pais en dato2, provincia en dato3
      acreditado.dato1 = this.formData.nombreMedio;
      acreditado.dato2 = this.formData.paisResidencia?.descripcion;

      if (this.formData.paisResidencia?.id == "+54") {
        acreditado.dato3 = this.formData.provincia?.descripcion;
      } else {
        acreditado.dato3 = this.formData.provinciaEstado;
      }

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

        Swal.fire({
          title: "Registro exitoso",
          html: "Recibimos de manera correcta los datos para tu acreditación.<br>En los próximos días recibirás un e-mail con el estado de tu solicitud de inscripción. <br>Muchas gracias.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://www.exposicionrural.com.ar/";
        });

      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
    this.cargos = jsonCargos;
  }
});
</script>
